jQuery( document ).on( "page.ready", function () {
  $ = jQuery;

  if ( $( "main.contact" ).length ) {
    var smcontroller = new ScrollMagic.Controller();

    // The Forms Slider
    // ---
    var $formSlider = $( ".form-area .owl-carousel" );
    $formSlider.owlCarousel( {
      autoplay: false,
      loop: false,
      nav: false,
      items: 1,
      singleItem: true,
      rewind: true,
      rewindNav: true,
      rewindSpeed: 0,
      dots: false,
      lazyLoad: true,
      autoHeight: true,
      mouseDrag: false
    } ).on( "changed.owl.carousel", function ( event ) {
      var $navItems = $( '.form-toggle >.container' ).children();

      $( $navItems ).removeClass( 'active' );
      $( $navItems[ event.item.index ] ).addClass( 'active' );
    } );

    $( '.form-toggle >.container button' ).click( function ( event ) {
      $formSlider.trigger( "to.owl.carousel", $( this ).index() );
      $( this ).parent().children().removeClass( 'active' );
      $( this ).addClass( 'active' );
    } );
    // END The Forms Slider

  }
} );